import { Skeleton } from "@heroui/react";

/**
 * A card-shaped placeholder while a list loads: the frame and the spacing of
 * NewsCard, neutral blocks where the chips, the avatar, the date line, the
 * title and the three lines of excerpt go. Decorative: the list names the
 * loading state itself.
 */
export function NewsCardPlaceholder() {
  return (
    <article
      aria-hidden
      className="flex w-full flex-col gap-[25px] rounded-lg border border-slate-100 bg-surface px-[15px] pt-[13px] pb-[13px] shadow-surface"
    >
      <div className="flex w-full gap-2.5">
        <div className="flex min-w-0 flex-1 flex-col gap-[18px]">
          <div className="flex flex-col gap-[13px]">
            <div className="flex items-center gap-[9px]">
              <Skeleton className="h-[22px] w-16 rounded-2xl" />
              <Skeleton className="h-[22px] w-32 rounded-2xl" />
            </div>
            <div className="flex items-center gap-[13px]">
              <Skeleton className="size-10 shrink-0 rounded-full" />
              <div className="flex flex-col gap-2 py-1">
                <Skeleton className="h-3 w-40" />
                <Skeleton className="h-3 w-56" />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {/* one block per text line, padded to the card's line heights (title leading-6, excerpt leading-5) */}
            <div className="py-1">
              <Skeleton className="h-4 w-3/4" />
            </div>
            <div className="flex flex-col">
              {["w-full", "w-full", "w-2/3"].map((width, line) => (
                <div key={line} className="py-1">
                  <Skeleton className={`h-3 ${width}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex w-4 shrink-0 flex-col items-start justify-between">
          <Skeleton className="size-4" />
          <Skeleton className="size-4" />
        </div>
      </div>
    </article>
  );
}
